// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"Testimonials_testimonials__Zff1D","testimonials__track":"Testimonials_testimonials__track__aN4UT"};